import classNames from "classnames";
import { Switch, Route } from "react-router-dom";
import { useLocation, useParams, useRouteMatch } from "react-router";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { PageNav } from "@ugg/shared/components/common/PageNav";
import { ChampionHome } from "./ChampionHome";
import { ChampionLeaderboards } from "@ugg/shared/components/Leaderboards/ChampionLeaderboards";
import { REGION_OPTIONS_ALL } from "@ugg/shared/components/Leaderboards/leaderboard-filters";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { AppRoutes, getChampionLeaderboard } from "@ugg/shared/routes/app-routes";

export function ChampionHomePage({ className }: { className?: string }) {
  const { getChampionName, getChampionIdByName } = getRiotAssetsContext();
  const location = useLocation();
  const pathname = location?.pathname;
  const match = useRouteMatch();
  const { champion } = useParams<{ champion?: string }>();
  const queryParams = useQueryString();
  const { region } = queryParams || {};
  const regionFull = region && REGION_OPTIONS_ALL.find((reg) => reg.value === region);
  const { fullLabel } = regionFull || {};

  const id = champion && getChampionIdByName(champion);
  const champName = getChampionName(id);

  const getTitleAndDesc = (pathname: string) => {
    let title = "LoL Champions Search";
    let subtitle = "Discover the best builds for every champion";
    if (pathname && champName) {
      if (pathname === AppRoutes.CHAMPION_HOME) {
        title = "LoL Champions Search";
        subtitle = "Discover the best builds for every champion";
      } else if (match.path === AppRoutes.CHAMPION_LEADERBOARD) {
        if (fullLabel) {
          title = `Best ${champName} Players in ${fullLabel === "World" ? `the ${fullLabel}` : fullLabel}`;
          subtitle = `${fullLabel}'s best ${champName} players, one-tricks, pros, and more. U.GG's Champion Leaderboard for all regions in D2+.`;
        } else {
          title = `Best ${champName} Players in the World`;
          subtitle = `World's best ${champName} players, one-tricks, pros, and more. U.GG's Champion Leaderboard for all regions in D2+.`;
        }
      }
    }
    return { title, subtitle };
  };

  const { title, subtitle } = getTitleAndDesc(pathname) || {};

  const navTabs = [
    {
      to: AppRoutes.CHAMPION_HOME,
      label: "Champions",
      reset: true,
    },
    {
      to: getChampionLeaderboard(),
      label: "Leaderboards",
    },
  ];

  return (
    <div className={classNames("w-full", className)}>
      <div className="my-[24px] font-barlow text-[36px] leading-[34px] font-semibold text-white">
        <h1 className="font-barlow text-[36px] leading-[34px] font-semibold text-white">{title}</h1>
        <h2 className="mt-[12px] text-[18px] font-medium text-lavender-50">{subtitle}</h2>
      </div>
      <PageNav tabs={navTabs} />
      <Switch>
        <Route path={AppRoutes.CHAMPION_LEADERBOARD} component={ChampionLeaderboards} />
        <Route path={AppRoutes.CHAMPION_HOME}>
          <ChampionHome className="mt-[36px]" />
        </Route>
      </Switch>
    </div>
  );
}
